import AsyncStorage from '@react-native-async-storage/async-storage';
import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'opened_test_apps_v1';

/**
 * Tracks which test-app cards the user has already opened locally.
 * Used to gate the "J'ai testé" confirmation button: it only appears
 * after the user has actually tapped through to the app at least once.
 *
 * Persisted in AsyncStorage so the button stays available across tab
 * switches and app restarts (until the user marks it tested in DB).
 */
export function useOpenedApps() {
  const [openedAppIds, setOpenedAppIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    (async () => {
      try {
        const raw = await AsyncStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        const arr = JSON.parse(raw) as string[];
        if (Array.isArray(arr)) setOpenedAppIds(new Set(arr));
      } catch {
        // ignore parsing or storage errors
      }
    })();
  }, []);

  const markOpened = useCallback((id: string) => {
    setOpenedAppIds((prev) => {
      if (prev.has(id)) return prev;
      const next = new Set(prev);
      next.add(id);
      AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(next))).catch(
        () => undefined
      );
      return next;
    });
  }, []);

  return { openedAppIds, markOpened };
}
